module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/group/group.html
// module id = 507
// module chunks = 0